import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';

import Alert from 'components/Alert';

/*global FB*/

const signInUser = gql`
  mutation SignInUser($token: String!) {
    signInUser(fb_token: $token) {
      user {
        access_token
      }
    }
  }
`;

class FacebookLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      closing: false,
      error: false,
      loading: false,
      active: false,
    };
  }

  componentDidMount() {
    if (!this.getToken()) {
      this.setState({ active: true });
      this.loadSdkAsync();
    } else {
      this.closeLogin();
    }
  }

  getLoginStatus = () => {
    FB.getLoginStatus(response => {
      if (response.status === 'connected') {
        this.loginApp(response);
      } else {
        this.logout();
      }
    });
  };

  getToken = () => {
    return localStorage.getItem('token');
  };

  closeLogin = () => {
    this.props.onLogin();
    this.setState({ closing: false, loading: false, active: false });
  };

  hideLogin = () => {
    this.setState({
      closing: true,
    });
  };

  loadSdkAsync = () => {
    if (!document.getElementById('facebook-jssdk')) {
      window.fbAsyncInit = () => {
        FB.init({
          appId: process.env.REACT_APP_FB_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v3.0',
        });

        this.getLoginStatus();
      };

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/pt_PT/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    } else {
      this.getLoginStatus();
    }
  };

  loginApp = response => {
    this.setState({ loading: true });

    this.props.client
      .mutate({ mutation: signInUser, variables: { token: response.authResponse.accessToken } })
      .then(({ data }) => {
        const user = data.signInUser.user;

        localStorage.setItem('token', user.access_token);
        this.closeLogin();
      })
      .catch(() => this.setError('Ocorreu um erro, por favor tente novamente.'));
  };

  loginFB = () => {
    if (typeof FB !== 'undefined' && typeof FB.login === 'function') {
      FB.login(this.loginApp);
    } else {
      this.setError('Não foi possível estabelecer um ligação ao Facebook, verifique que não está a bloquear redes sociais.');
    }
  };

  logout = () => {
    localStorage.removeItem('token');
    this.props.onLogout();
    this.setState({ closing: false, loading: false, active: true });
  };

  setError = msg => {
    this.setState({ loading: false, error: msg });
  };

  render() {
    const { closing, error, loading, active } = this.state;

    return (
      active && (
        <div className={'overlay' + (closing ? ' closing' : '')} onAnimationEnd={() => (closing ? this.closeLogin() : null)}>
          <p>Para poder participar é necessário ter sessão iniciada no Facebook.</p>
          <button className={`overlay__button ${loading ? ' loading' : ''}`} onClick={this.loginFB}>
            Login
          </button>
          <Link to="/" className="overlay__cancel">
            Sair do passatempo
          </Link>
          {error && <Alert>{error}</Alert>}
        </div>
      )
    );
  }
}

export default withApollo(FacebookLogin);
